import * as Pinia from 'pinia';

import {easyDeepClone} from "@/common/utils/common";
import {createUnistorage} from "pinia-plugin-unistorage";

const pinia = Pinia.createPinia()

export const piniaReset: Pinia.PiniaPlugin = ({store}) => {
    const initialState = easyDeepClone(store.$state)
    store.$reset = () => {
        store.$patch($state => Object.assign($state, initialState))
    }
}
// 修复setup模式$reset无效的问题
pinia.use(piniaReset)

// 将插件添加到 pinia 实例上
pinia.use(createUnistorage())

export default pinia
